module.exports = __webpack_public_path__ + "static/media/invitation.572f5028.svg";